module.exports = __webpack_public_path__ + "img/banner1.7d6f106b.png";